import { useAuth } from '@/features/auth';
import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet, useMatches } from '@tanstack/react-router';
import * as React from 'react';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  auth: ReturnType<typeof useAuth>;
}>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <Meta>
      <Outlet />
    </Meta>
  );
}

function Meta({ children }: { children: React.ReactNode }) {
  const matches = useMatches();
  const meta = matches.at(-1)?.meta?.find((meta) => meta?.title);

  React.useEffect(() => {
    document.title = [meta?.title ?? 'Volve Eval Web App'].filter(Boolean).join(' · ');
  }, [meta]);

  return children;
}
